module.exports = __webpack_public_path__ + "static/media/Aveny soffa liver 3491 ben 051 valnöt detalj 10.e1655637.jpg";